var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content white"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"product-cate-wrapper"},_vm._l((_vm.dataList),function(category,index){return _c('router-link',{key:index,staticClass:"cate-block",attrs:{"to":{
          name: 'ProductList',
          params: {
            category_id: category.id,
            vendor_id: _vm.$route.params.vendor_id
          }
        }}},[_c('div',{staticClass:"cate-img"},[_c('img',{attrs:{"src":category.cover,"alt":category.name}})]),_c('div',{staticClass:"catename"},[_vm._v(_vm._s(category.name))])])}),1),(!_vm.loadAll)?_c('scroll-loader',{attrs:{"loader-method":_vm.getData,"loader-enable":!_vm.loadAll}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }